import script from "./MainBodyLr.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBodyLr.vue?vue&type=script&setup=true&lang=js"

import "./MainBodyLr.vue?vue&type=style&index=0&id=7572efbf&lang=scss&scoped=true"

import exportComponent from "/Users/qiuxiaofeng/Desktop/交接/assistant_eclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7572efbf"]])

export default __exports__